import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
// ⚠️ 要放在所有會用到 dayjs 的模組之前：這支負責 extend utc / timezone /
// customParseFormat 並設定店家預設時區，晚載入的話先跑的模組會拿不到 .tz()
import './utils/timezone'
import { Provider } from 'react-redux'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { store } from './store'
import { ConfigProvider } from 'antd'
import zh_TW from 'antd/es/locale/zh_TW'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfigProvider
        locale={zh_TW}
        theme={{
          token: {
            colorPrimary: '#d5728a',
            colorPrimaryBorder: '#F2B3C0'
          }
        }}
      >
        <App />
      </ConfigProvider>
    </Provider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
